import { createMiddlewareAction } from "./createMiddlewareAction";
import { endpoints } from "../api/endpoints";
import { phasesTypes } from "../constantes/actionTypes";

export const phasesActions = {
  getAllPhases: () =>
    createMiddlewareAction({
      successType: phasesTypes.GET_ALL_PHASES_SUCCESS,
      failureType: phasesTypes.GET_ALL__PHASES_FAILURE,
      method: "GET",
      endpoint: endpoints.GET_ALL_PHASES,
    }),
};
